"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var plLocaleData = require("i18next-icu/locale-data/pl");
exports.default = plLocaleData;
//# sourceMappingURL=pl.js.map